import { CommonNS } from "../../../../Common/CommonNS.js";
import { ModelNS } from "../../Model/ModelNS.js";
import { VONS } from "../../VO/VONS.js";
export class CommandMController {
  constructor({ command_m, svg_el, getPathElCTM, getPathEditorLayerElCTM }) {
    this._observer_set = new Set();
    this._svg_el = svg_el;
    this._getPathElCTM = getPathElCTM;
    this._getPathEditorLayerElCTM = getPathEditorLayerElCTM;
    this._command_m = command_m;
    this._command_m_vo = {
      target_point: {
        x: 0,
        y: 0,
        is_show: true,
        is_selected: false,
      },
    };
    command_m.subscribe((vo) => this._observeCommandM(vo));
  }
  subscribe(observer) {
    if (this._observer_set.has(observer)) {
      throw new Error(`이미 등록된 observer 입니다.`);
    }
    observer(this._command_m_vo);
    this._observer_set.add(observer);
    return () => {
      this._observer_set.delete(observer);
    };
  }
  click(click_vo) {
    this._command_m.click(click_vo);
  }
  _observeCommandM(command_m_vo) {
    const path_el_ctm = this._getPathElCTM();
    const path_editor_layer_el_ctm_inverse =
      this._getPathEditorLayerElCTM().inverse();
    const target_point = CommonNS.UtilNS.createSVGPoint(this._svg_el)([
      command_m_vo.target_point.x,
      command_m_vo.target_point.y,
    ])
      .matrixTransform(path_el_ctm)
      .matrixTransform(path_editor_layer_el_ctm_inverse);
    this._command_m_vo = {
      target_point: {
        x: target_point.x,
        y: target_point.y,
        is_show: true,
        is_selected: command_m_vo.target_point.is_selected,
      },
    };
    this._notify(this._command_m_vo);
  }
  _notify(command_m_vo) {
    for (const observer of this._observer_set) {
      CommonNS.UtilNS.tryNoop(() => observer(command_m_vo));
    }
  }
}
